import patientClient from '@/axiosClients/patientClient';
import psychologyConsultationClient from "@/axiosClients/psychologyConsultationClient";


const getPatientById = (id, consultationId = null) => {
    const endpoint = consultationId ? `/patient/${id}/${consultationId}` : `/patient/${id}`;
    return patientClient.get(endpoint);
}

const acceptInformedConsent = (patientId) => {
    return patientClient.post(`/patient/accept-informed-consent/${patientId}`)
}
const updateContactInformation = (info) => {
    return patientClient.post(`/update-contact-information`, info);
}

const getExcelUserInformation = (params) => {
    return patientClient.get(`/patient/report`, {
        params: params,
        responseType: 'blob'
    });
}

const updateSessionType = (data) => {
    return patientClient.post(`/patient/update-session-type`, data);
}

export default {
    getPatientById,
    acceptInformedConsent,
    updateContactInformation,
    getExcelUserInformation,
    updateSessionType
}
